import { isArray } from 'util';
import { parseNumber } from '../../utils/number.utils';
import { Operation } from '../operation';
import { Program } from '../program';
import { ProgramManufacturingOrder } from '../program-manufacturing-order';

export class ProgramBuilder {
  static fromJson(json) {
    return (json)
      ? new Program(
        json.hash,
        json.reference,
        parseNumber(json.time),
        parseNumber(json.timeDeviation),
        parseNumber(json.timeWithDeviation),
        json.tool,
        json.sourceHash,
        json.sourceName,
        json.partHash,
        json.partName,
        json.operationHash,
        json.operationName,
        parseNumber(json.operationIndex),
        parseNumber(json.index)
      )
      : null;
  }

  static fromList(list) {
    return (isArray(list)) ? list.map(ProgramBuilder.fromJson) : [];
  }

  static fromOperationJson(json) {
    return (json)
      ? new Operation(
        json.hash,
        json.name,
        parseNumber(json.index)
      )
      : null;
  }

  static fromOperationList(list) {
    return (isArray(list)) ? list.map(ProgramBuilder.fromOperationJson) : [];
  }

  static fromProgramManufacturingOrderJson(json) {
    return (json)
      ? new ProgramManufacturingOrder(
        json.hash,
        json.reference,
        parseNumber(json.time),
        json.manufacturingOrderHash,
        json.manufacturingOrderCode,
        json.manufacturingOrderProjectNumber,
        json.materialHash,
        json.materialFileName
      )
      : null;
  }

  static fromProgramManufacturingOrderList(list) {
    return (isArray(list)) ? list.map(ProgramBuilder.fromProgramManufacturingOrderJson) : [];
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/program.builder.ts